import { useTranslation } from "react-i18next";
import Layout from "@/components/feature/Layout";
import SEO from "@/components/feature/SEO";
import ServicePageLayout from "./components/ServicePageLayout";
import { servicesOverview } from "@/mocks/services";

export default function CongelacionPage() {
  const { t } = useTranslation("home");
  const data = servicesOverview.services.find((s) => s.slug === "congelacion");

  return (
    <Layout>
      <SEO
        title="Congelación y Refrigeración Industrial | Ventra Core León"
        description="Soluciones de congelación, refrigeración y enfriamiento para tiendas de autoservicio, restaurantes, agroindustria y farmacéutica en León, Guanajuato."
        keywords="congelación, refrigeración industrial, cámaras frigoríficas, refrigeración comercial, congelación León, refrigeración Guanajuato"
        canonical="https://ventracore.com.mx/congelacion"
        schemas={[
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "@id": "https://ventracore.com.mx/congelacion#service",
            "serviceType": "Congelación y Refrigeración Industrial",
            "provider": { "@id": "https://ventracore.com.mx/#organization" },
            "areaServed": {
              "@type": "City",
              "name": "León",
            },
            "description": "Soluciones de congelación, refrigeración y enfriamiento para diversos sectores en León, Guanajuato.",
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Inicio",
                "item": "https://ventracore.com.mx/",
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Servicios",
                "item": "https://ventracore.com.mx/servicios",
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Congelación",
                "item": "https://ventracore.com.mx/congelacion",
              },
            ],
          },
        ]}
      />
      <ServicePageLayout
        title={t("servicesPage.congelationTitle")}
        subtitle={t("servicesPage.congelationSubtitle")}
      >
        <div className="max-w-5xl mx-auto">
          <p className="text-sm md:text-base text-text-muted leading-relaxed text-center mb-10 md:mb-14">
            {t("servicesPage.congelationDesc")}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            <div className="bg-surface rounded-lg p-5 md:p-6 border border-transparent hover:border-brandgreen/20 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-brandgreen/10 rounded-md mb-4">
                <span className="w-6 h-6 flex items-center justify-center text-brandgreen">
                  <i className="ri-store-2-line" />
                </span>
              </div>
              <h4 className="text-base font-bold text-magenta mb-2">
                {t("servicesPage.congelation.retail")}
              </h4>
              <p className="text-sm text-text-muted leading-relaxed">
                {t("servicesPage.congelation.retailDesc")}
              </p>
            </div>

            <div className="bg-surface rounded-lg p-5 md:p-6 border border-transparent hover:border-brandgreen/20 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-brandgreen/10 rounded-md mb-4">
                <span className="w-6 h-6 flex items-center justify-center text-brandgreen">
                  <i className="ri-restaurant-line" />
                </span>
              </div>
              <h4 className="text-base font-bold text-magenta mb-2">
                {t("servicesPage.congelation.restaurant")}
              </h4>
              <p className="text-sm text-text-muted leading-relaxed">
                {t("servicesPage.congelation.restaurantDesc")}
              </p>
            </div>

            <div className="bg-surface rounded-lg p-5 md:p-6 border border-transparent hover:border-brandgreen/20 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-brandgreen/10 rounded-md mb-4">
                <span className="w-6 h-6 flex items-center justify-center text-brandgreen">
                  <i className="ri-seedling-line" />
                </span>
              </div>
              <h4 className="text-base font-bold text-magenta mb-2">
                {t("servicesPage.congelation.agro")}
              </h4>
              <p className="text-sm text-text-muted leading-relaxed">
                {t("servicesPage.congelation.agroDesc")}
              </p>
            </div>

            <div className="bg-surface rounded-lg p-5 md:p-6 border border-transparent hover:border-brandgreen/20 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-brandgreen/10 rounded-md mb-4">
                <span className="w-6 h-6 flex items-center justify-center text-brandgreen">
                  <i className="ri-hospital-line" />
                </span>
              </div>
              <h4 className="text-base font-bold text-magenta mb-2">
                {t("servicesPage.congelation.pharma")}
              </h4>
              <p className="text-sm text-text-muted leading-relaxed">
                {t("servicesPage.congelation.pharmaDesc")}
              </p>
            </div>
          </div>

          {data && (
            <div className="mt-10 md:mt-14 rounded-lg overflow-hidden">
              <img
                src={data.image}
                alt={data.title}
                className="w-full h-64 md:h-80 object-cover"
              />
            </div>
          )}

          <p className="text-sm text-text-muted text-center mt-8">
            {t("servicesPage.contact")}
          </p>
        </div>
      </ServicePageLayout>
    </Layout>
  );
}